import React from 'react';
import { ShiftProviderUser } from 'models';
import { Avatar, Grid } from '@mui/material';
import { Colors, Text } from 'library';
import { Link } from 'react-router-dom';

export default function ProviderDisplay({
    provider,
    containerStyles,
}: {
    provider: ShiftProviderUser;
    containerStyles?: React.CSSProperties;
}) {
    return (
        <Grid container item direction="row" style={containerStyles}>
            <Avatar
                src={provider.profile_picture?.image ? provider.profile_picture.image : undefined}
                alt={`${provider.first_name} ${provider.last_name}`}
                style={{
                    margin: 0,
                    padding: 0,
                    height: 25,
                    width: 25,
                    backgroundColor: Colors.darkNavy,
                    fontSize: '1rem',
                    marginRight: 15,
                }}
            >
                {provider.first_name[0] + provider.last_name[0]}
            </Avatar>
            <Link to={`/provider/${provider.id}`}>
                <Text variant="body1" bold textStyle={{ textDecorationLine: 'underline', cursor: 'pointer' }}>
                    {provider.first_name} {provider.last_name}
                </Text>
            </Link>
        </Grid>
    );
}
